import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-appbar',
    templateUrl: './appbar.component.html',
    styleUrls: ['./appbar.component.css'],
    standalone: false
})
export class AppbarComponent implements OnInit {

  trackerUrl: string;
  
  constructor() {
    this.trackerUrl = environment.baseUrl
  }

  ngOnInit(): void {
  }

}
